var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeavesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7CB342",
    d: "M30,76.664c0,4.371,0.555,8.848,1.582,13.336h6.836c-1.104-4.271-1.751-8.725-1.751-13.336v-0.462 c26.298-3.287,46.662-25.681,46.665-52.866c-15.992,0-30.305,7.075-40.077,18.226C42.839,30.094,38.457,18.752,30,10l0.003,0.005 C12.226,28.411,12.222,58.259,30,76.664z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCEDC8",
    d: "M37.227,69.438c19.952-3.119,35.76-18.925,38.877-38.875C56.147,33.677,40.342,49.484,37.227,69.438z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCEDC8",
    d: "M30.004,20.653C21.11,34.307,21.106,52.363,30,66.013C38.895,52.359,38.895,34.303,30.004,20.653z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeavesIcon);
export default __webpack_public_path__ + "static/media/leaves-icon.7cdf77080fa1b3333526a55879a1e7c5.svg";
export { ForwardRef as ReactComponent };